// 파일 → base64 data URL 변환 — 앰버서더 계약 파일(통장사본/사업자등록증) 업로드용.
// 서버는 파일을 base64 data URL 문자열(JSON 필드)로 받아 DB 에 저장한다 (별도 오브젝트 스토리지 없음).

// 서버 캡(base64 data URL 7,000,000자)과 페어인 업로드 상한 — 바이너리 기준 5MB.
export const CONTRACT_FILE_MAX_BYTES = 5 * 1024 * 1024;

export const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

// Content-Disposition 헤더에서 파일명을 꺼낸다 — 다운로드 파일명의 단일 소스는 서버다.
// RFC 5987 형식(filename*=UTF-8''%EB%94%94...)을 우선 쓰고, 없으면 filename="..." 을 본다.
// 헤더가 없거나(CORS 미노출·구버전 서버) 파싱에 실패하면 null — 호출처가 대체 이름을 쓴다.
export const fileNameFromContentDisposition = (
  header?: string | null
): string | null => {
  if (!header) return null;
  const encoded = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim()) || null;
    } catch (e) {
      // 잘못 인코딩된 헤더 — 아래 plain 형식으로 넘어간다
    }
  }
  const plain = header.match(/filename\s*=\s*"?([^";]+)"?/i);
  return plain ? plain[1].trim() || null : null;
};

// Blob 을 파일로 저장 — 서버 바이너리 응답(체결본 PDF 등) 다운로드용.
export const saveBlobAsFile = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  // 즉시 revoke 하면 다운로드가 시작되기 전에 무효화될 수 있다 — 여유를 두고 해제
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
